const ReducerTypes = {
  HEADER_MESSAGE: "HEADER_MESSAGE",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  PROFILE_DETAIL: "PROFILE_DETAIL",
  CATEGORIES: "CATEORIES",
  PARAMS: "PARAMS",
  BUSINESSES_LIST: "BUSINESSES_LIST",
  TOGGLE_LOADING: "TOGGLE_LOADING",
  All_BLOGS: "All_BLOGS",
  BLOGS_PARAMS: "BLOGS_PARAMS",
  SINGLE_BLOG: "SINGLE_BLOG",
  BLOG_ID: "BLOG_ID",
};

export default ReducerTypes;
